import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PaymentMethodsHandlerService } from '../modules/cart/lib-cart/shared/services/payment-methods-handler.service';
import { InformationCollectorByPaymentService } from '../modules/information-collector-by-payment/collector/services/information-collector-by-payment.service';
import { AwbLookUpService } from './awb-look-up.service';
import { CartBillService } from './cart.service';
import { ExtraItemsService } from './extra-items.service';
import { FlightService } from './flight.service';
import { PaymentConfirmationService } from './payment-confirmation.service';
import { SearchByFlightService } from './search-by-flight.service';
import { SummaryService } from './summary/summary.service';

/**
 * Service that is responsible for cleaning the user information that is stored in the cache
 */
@Injectable({
    providedIn: 'root',
})
export class ResetInformationService {
    constructor(
        private summaryService: SummaryService,
        private awbLookUpService: AwbLookUpService,
        private searchByFlightService: SearchByFlightService,
        private flightService: FlightService,
        private paymentConfirmationService: PaymentConfirmationService,
        private extraItemsService: ExtraItemsService,
        private cartBillService: CartBillService,
        private informationCollectorByPaymentService: InformationCollectorByPaymentService,
        private paymentMethodsHandlerService: PaymentMethodsHandlerService
    ) {}

    resetUserInformation(resetAllInformation = false): Observable<string> {
        this.resetPaymentMethod();
        this.resetCustomerReference();
        this.resetTermsOfUse();
        this.resetNotes();
        this.resetSubmittedItems();
        this.resetExtraItems();

        if (resetAllInformation) {
            this.resetAllInformation();
        }

        return of('Complete');
    }

    resetAllInformation(): void {
        this.resetLocation();
        this.resetShipmentInfo();
        this.resetTypeSearch();
        this.resetFlightNumber();
        this.resetFlightInfo();
        this.resetDate();
        this.resetConfirmation();
    }

    private resetPaymentMethod(): void {
        this.paymentMethodsHandlerService.setPaymentMethodGuest(null);
        this.paymentMethodsHandlerService.resetGuestCreditCard();
        this.paymentMethodsHandlerService.setPaymentMethodSelected(null);
        this.paymentMethodsHandlerService.setPaymentMethodSelectedAboveThreshold(null);
        this.paymentMethodsHandlerService.resetGuestEcheck();
    }

    private resetCustomerReference(): void {
        this.informationCollectorByPaymentService.setCollectorForms(null, 0);
    }

    private resetTermsOfUse(): void {
        this.summaryService.setTermsOfUseValid(null);
    }

    private resetNotes(): void {
        this.summaryService.setNotesValid(null);
    }

    private resetLocation(): void {
        this.summaryService.setAndSaveLocationInStorage(null);
    }

    private resetShipmentInfo(): void {
        this.awbLookUpService.setAndSaveOnStorageShipmentInfo(null);
    }

    private resetTypeSearch(): void {
        this.summaryService.setAndSaveSearchTypeInStorage(null);
    }

    private resetFlightInfo(): void {
        this.searchByFlightService.setAndSaveOnStorageFlightInfo(null);
    }

    private resetFlightNumber(): void {
        this.flightService.setFlightNumber(null);
    }

    private resetDate(): void {
        this.flightService.setFlightDate(null);
    }

    private resetConfirmation(): void {
        this.paymentConfirmationService.setConfirmationInformation(null);
    }

    private resetExtraItems(): void {
        this.extraItemsService.resetAccessoryAdded();
    }

    private resetSubmittedItems(): void {
        this.cartBillService.resetSubmittedItems();
    }
}
